import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { omitTopLevelId } from '#/api/adapters/patchBody';

/** 僅 DRAFT。 */
export async function updateStockTransfer(id, payload) {
  const { data: raw } = await request.patch(
    `/ims/stock-transfer/${id}`,
    keysToSnake(omitTopLevelId(payload)),
  );
  return parseVer4DetailResponse(raw);
}
